export const formatToNOK = (amount: number, withCurrency = false) => {
  const formattedAmount = Intl.NumberFormat('nb-NO').format(amount);
  return withCurrency ? `${formattedAmount} kr` : formattedAmount;
};
export const getNewPriceWithPoints = (originalPrice: number, currentPointsAmount: number) => {
  return Math.max(originalPrice - currentPointsAmount, 0);
};
export const getOlioPointsRounded = (points: number) => Math.ceil(points);
